<template>
  <div class="auto-done-enrolls--content">
    <div class="input-block">
      <div @dblclick="doneSubmit" class="btn btn-sm btn-outline-info">Завершить старые записи</div>
      <div class="hint">Двойной клик по кнопке</div>
    </div>
  </div>
</template>

<script>
import enrollRepository from "../../../repositories/enroll";

export default {
  /** Переводит все записи компании в статус "Выполнено" до текущего времени */
  name: "AutoDoneEnrolls",
  components: {},
  data() {
    return {

    };
  },
  props: {

  },
  watch: {

  },
  computed: {

  },
  methods: {
    doneSubmit(){
      this.$store.dispatch("startPreloader");
      enrollRepository.autoDone().then(resp => {
        if (resp.data.result === "ok") {
          this.$store.dispatch("addNotification", {
            text: 'Все старые записи успешно переведены в статус Выполненных. Обновите страницу',
            time: 4,
            color: "success"
          });
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("stopPreloader");
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    }
  },
  created() {}
};
</script>

<style scoped lang="less">

</style>
